const initialState = {
  allStats: {
    users: {
      total: 0,
      inUse: 0,
      notUsing: 0,
    },
    stations: {
      inUse: 0,
      available: 0,
      total: 0,
      unavailable: 0,
    },
    energy: {
      consumption: 0,
      monthCost: 0,
      monthIncome: 0,
      coin: ''
    },
    co2Saved: 0,
    treePercentageGoal: 0,
    cultivatedTree: 0
  }
}

export const statsReducer = (state = initialState, action) => {
  switch(action.type){
    case 'SET_ALL_STATS':
      return {
        ...state,
        allStats: action.allStats
      }

    default:
      return state
  }
}